import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchStyleDocuments,
  type StyleDocumentsListParams,
} from '@/api/my-styles';

function buildStyleDocumentsQs(params: StyleDocumentsListParams): string {
  const qs = new URLSearchParams({
    page: String(Math.max(1, params.page)),
    count: String(params.count),
  });
  if (params.name) qs.set('name', params.name);
  if (params.documentTypeId) qs.set('documentTypeId', params.documentTypeId);
  if (params.isArchived === true) qs.set('isArchived', 'true');
  if (params.sort) {
    const [field, dir] = params.sort.split(':');
    if (field) qs.set('sort', field);
    if (dir) qs.set('order', dir.toLowerCase());
  }
  return qs.toString();
}

export function styleDocumentsQueryOptions(
  styleId: string,
  params: StyleDocumentsListParams,
) {
  return queryOptions({
    queryKey: ['my-styles', 'style-documents', styleId, params] as const,
    queryFn: () => fetchStyleDocuments(styleId, buildStyleDocumentsQs(params)),
    enabled: !!styleId,
    staleTime: 60_000,
  });
}

export function useStyleDocumentsQuery(
  styleId: string,
  params: StyleDocumentsListParams,
) {
  return useQuery(styleDocumentsQueryOptions(styleId, params));
}
